// extracted by mini-css-extract-plugin
export var container = "SearchWidget-module--container--3Z21D";